<div class="sp-row__align">
  <mat-icon
    class="sp-color__accent sp-margin__right sp-icon__min-width"
    *ngIf="order?.channel == on_session_channel">
    face
  </mat-icon>
  <mat-icon
    class="sp-color__accent sp-margin__right sp-icon__min-width"
    *ngIf="order?.channel == off_session_channel">
    support_agent
  </mat-icon>
  <span
    *ngIf="show_label"
    class="sp-margin__quarter-left sp-text__ellipsized">
    {{ getChannelLabel(order?.channel) | translate }}
  </span>
</div>
